/* eslint-disable no-underscore-dangle */
import {configureStore} from '@reduxjs/toolkit';
import scrollReducer from '@components/shared/Documents/scrollSlice';
import appReducer from '@components/appSlice';
import accountRegistrationReducer from '@components/AccountRegistration/accountRegistrationSlice';
import adminReducer from '@components/AdminPanel/adminSlice';
import userReducer from '@components/Login/userSlice';
import dashboardReducer from '@components/Dashboard/dashboardSlice';
import dashboardReducerV2 from '@components/DashboardV2/dashboardSlice';
import transactionsReducer from '@components/Transactions/transactionsSlice';
import archiveReducer from '@components/Archive/archiveSlice';
import transactionReducer from '@components/Transaction/transactionSlice';
import templatesReducer from '@components/Templates/templatesSlice';
import templateReducer from '@components/Template/templateSlice';
import delegationReducer from '@components/Delegation/delegationSlice';
import sendersReducer from '@components/Delegation/sendersSlice';
import accountSettingsReducer from '@components/AccountSettings/accountSettingsSlice';
import passwordReducer from '@components/AccountSettings/ChangePassword/passwordSlice';
import twoFactorReducer from '@components/AccountSettings/TwoFactorAuth/twoFactorSlice';
import recipientsReducer from '@components/Packages/Recipients/recipientsSlice';
import designerReducer from '@components/Designer/designerSlice';
import brandSettingsReducer from '@components/AdminPanel/ThemesAndStyles/brandSettingsSlice';
import brandsReducer from '@components/AdminPanel/Brands/brandsSlice';
import rolesReducer from '@components/AdminPanel/Roles/rolesSlice';
import usersReducer from '@components/AdminPanel/UserManagement/usersSlice';
import emailAliasesReducer from '@components/AccountSettings/EmailAliases/emailAliasesSlice';
import reportsReducer from '@components/Reports/reportsSlice';
import signerUiReducer from '@components/SignerUi/signerUiSlice';
import infoArticleReducer from '@components/shared/InfoArticle/infoArticleSlice';
import aiReducer from '@components/AI/aiSlice';
import userRegistrationReducer from '@components/UserRegistration/userRegistrationSlice';

let initialState;
if (typeof window !== 'undefined') {
    initialState = window.__INITIAL_STATE__;
    delete window.__INITIAL_STATE__;
}

export default () => configureStore({
    preloadedState: initialState,
    reducer: {
        accountRegistration: accountRegistrationReducer,
        app: appReducer,
        admin: adminReducer,
        user: userReducer,
        dashboard: dashboardReducer,
        dashboardV2: dashboardReducerV2,
        transactions: transactionsReducer,
        archive: archiveReducer,
        transaction: transactionReducer,
        templates: templatesReducer,
        template: templateReducer,
        delegation: delegationReducer,
        senders: sendersReducer,
        accountSettings: accountSettingsReducer,
        password: passwordReducer,
        twoFactor: twoFactorReducer,
        recipients: recipientsReducer,
        designer: designerReducer,
        brandSettings: brandSettingsReducer,
        brands: brandsReducer,
        roles: rolesReducer,
        users: usersReducer,
        emailAliases: emailAliasesReducer,
        reports: reportsReducer,
        signerUi: signerUiReducer,
        infoArticle: infoArticleReducer,
        ai: aiReducer,
        scroll: scrollReducer,
        userRegistration: userRegistrationReducer
    }
});
